import React, { Fragment } from 'react';

const WheelchairPt2 = () => (
  <Fragment>
    <hr />
    <h4>Vehicle exit</h4>
    <ol className="new-course__body__content__olist">
      <li>
        Look for a clear area away from traffic and on an area with a flat, even surface that the ramp can lay flat on.
      </li>
      <li>Ask first, then remove the shoulder belt from the lap belt. </li>
      <li>
        Remove the lap belt by pressing the red release button on the belt buckle then remove both ends from the back
        retractors.
      </li>
      <li>
        Remove the 4 J Hooks by pressing the red levers on the retractor with your hand or foot to remove the tension.
        Then take the hooks off and retract the belts to the retractor.
      </li>
      <li>
        Remove retractors if any of the retractors are a tripping hazard or get in the way of removing the wheelchair
        then remove them.
      </li>
      <li>Unfold the ramp. </li>
      <li>
        Safely descend down the ramp. Make sure to offer assistance to the curb for people who use a manual wheelchair.
        Offer your assistance to guide a person with vision loss.
      </li>
    </ol>

    <h5>Manual chair assistance</h5>
    <ul className="new-course__body__content__olist--ulist">
      <li>
        Ask the person using a wheelchair to release their brakes and position themselves at the top of the ramp facing
        in, or assist if requested.
      </li>
      <li>Back down the ramp looking over your shoulder to be sure there are no obstacles in your way.</li>
      <li>
        Stay behind the passenger to control their speed. Move your passenger to a spot where they are safe and have
        access to their destination.
      </li>
      <li>
        Ask if there is anything else they need before you leave (never leave your passenger without telling them and
        seeking their agreement).
      </li>
    </ul>

    <h5>Power chair assistance</h5>
    <ul className="new-course__body__content__olist--ulist">
      <li>
        Ask the person using a power wheelchair to power on and position themselves at the top of the ramp facing out,
        or assist if requested.
      </li>
      <li>Stand on the ground beside the ramp facing the passenger.</li>
      <li>The passenger will drive down the ramp.</li>
      <li>Assist with posture and balance if requested with a hand on their shoulder.</li>
      <li>
        Ensure the passenger is safe and has access to their destination. Ask if there is anything else they need before
        you leave.
      </li>
    </ul>
  </Fragment>
);

export default WheelchairPt2;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewWheelchairPt2.js